import React, { useState, useEffect } from "react";
import {
  StyledSlider,
  StyledSliderBox,
  StyledSliderContainer,
  StyledSliderRange,
  StyledSliderTrack,
  StyledThumbLeft,
  StyledTickDot,
  StyledTickItem,
  StyledRangeContainer,
} from "./LanguageSlider.styled";
import { BodyTyp } from "../Typography/Typography";
import { FontWeightEnum } from "../../types/AppTypes";
import {
  CEFR_LEVELS,
  maxLevel,
  minLevel,
} from "../../constants/LanguageConstants";

interface LanguageSliderProps {
  value?: number;
  onChange: (value: number) => void;
  title?: string;
  disabled?: boolean;
}
export const LanguageSlider = ({
  onChange,
  value,
  title,
  disabled,
}: LanguageSliderProps) => {
  const step = 1;

  const [minVal, setMinVal] = useState<number>(value ?? minLevel);
  const [rangeWidth, setRangeWidth] = useState<string>(
    value !== undefined ? `${(value / maxLevel) * 100}%` : "0%",
  );

  useEffect(() => {
    if (value !== undefined) {
      setMinVal(value);
    }
  }, [value]);

  useEffect(() => {
    if (minVal !== value) {
      onChange(minVal);
    }
  }, [minVal]);

  useEffect(() => {
    const percent = (minVal / maxLevel) * 100;
    setRangeWidth(minVal === maxLevel ? "100%" : `${percent}%`);
  }, [minVal, maxLevel]);

  return (
    <StyledRangeContainer>
      <StyledSliderBox>
        <div className="rounded-container-title">
          <BodyTyp variant="1" fontWeight={FontWeightEnum.SEMIBOLD}>
            {title}
          </BodyTyp>
        </div>
        <StyledSliderContainer $disabled={disabled}>
          <StyledThumbLeft
            type="range"
            min={minLevel}
            max={maxLevel}
            step={step}
            value={minVal}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              const val = Number(event.target.value);
              setMinVal(val);
            }}
            disabled={disabled}
          />
          <StyledSlider>
            {CEFR_LEVELS.map((level, index) => (
              <StyledTickItem
                key={index}
                $position={(index / maxLevel) * 100}
                $isBoundary={index === 0}
                $disabled={disabled}
                onClick={() => {
                  if (!disabled) {
                    setMinVal(index);
                  }
                }}
              >
                <StyledTickDot $active={index <= minVal} />
                <div className="label-levels">
                  <BodyTyp
                    fontWeight={FontWeightEnum.SEMIBOLD}
                    variant="3"
                    noTranslate
                  >
                    {level}
                  </BodyTyp>
                </div>
              </StyledTickItem>
            ))}
            <StyledSliderTrack />
            <StyledSliderRange width={rangeWidth} />
          </StyledSlider>
        </StyledSliderContainer>
      </StyledSliderBox>
    </StyledRangeContainer>
  );
};
